import {EXTERNAL_PDF} from 'features/intercept-file-download-anchor/model/constants';

/**
 * Оборачивает ссылку в тег для отображения в виде гиперссылки в полях react-quill,
 * либо возвращает изначальное значение
 *
 * <b>Особенности:</b>
 * - Меняет URL ссылки на постоянный:
 *   <i>/nalmon/api/microservices/get-pdf-file?url={url}&type=external_pdf</i>.
 * - Любые ссылки обрабатываются как ссылки для скачивания PDF-файлов через микросервис.
 *   Это осознанное допущение: если ссылка должна выполнять иное действие,
 *   она работать не будет.
 * @param {string | number | boolean | object} value - значение ячейки выделенной строки
 * @returns {ReturnType<value>}
 */
export const wrapLinkInAnchor = (value: string | number | boolean | object) => {
    if (typeof value === 'string' && value.startsWith('http')) {
        const baseUrl = new URL(value).origin;
        const pdfFileUrl = `${baseUrl}/nalmon/api/microservices/get-pdf-file?url=${value}&type=${EXTERNAL_PDF}`;

        return (
            `<a href="${pdfFileUrl}">${value}</a>`
        );
    }

    return value;
};
